var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0) t[p[i]] = s[p[i]];
  }
  return t;
};

import { Status, reduceStatuses } from './Resolver';
import { SegmentType, createSegment } from './Segments';
import { NodeMatcher, NaviNodeType } from './Node';

var PageMatcher =
/** @class */
function (_super) {
  __extends(PageMatcher, _super);

  function PageMatcher() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  PageMatcher.prototype.execute = function () {
    var resolutionIds = [];
    var status = Status.Ready;
    var error;
    var content;

    if (this.withContent && this.constructor.getContent) {
      var contentResolution = this.resolver.resolve(this.env, this.constructor.getContent);
      resolutionIds.push(contentResolution.id);
      content = contentResolution.value;
      status = reduceStatuses(status, contentResolution.status);
      error = error || contentResolution.error;
    } else {
      content = this.constructor.content;
    }

    var title;

    if (this.constructor.getTitle) {
      var titleResolution = this.resolver.resolve(this.env, this.constructor.getTitle);
      resolutionIds.push(titleResolution.id);
      title = titleResolution.value;
      status = reduceStatuses(status, titleResolution.status);
      error = error || titleResolution.error;
    } else {
      title = this.constructor.title;
    }

    var meta;

    if (this.constructor.getMeta) {
      var metaResolution = this.resolver.resolve(this.env, this.constructor.getMeta);
      resolutionIds.push(metaResolution.id);
      meta = metaResolution.value;
      status = reduceStatuses(status, metaResolution.status);
      error = error || metaResolution.error;
    } else {
      meta = this.constructor.meta;
    }

    return {
      resolutionIds: resolutionIds,
      segment: createSegment(SegmentType.Page, this.env, {
        title: title,
        meta: meta || {},
        status: status,
        error: error,
        content: content,
        remainingSegments: []
      })
    };
  };

  PageMatcher.isNode = true;
  PageMatcher.type = NaviNodeType.Page;
  return PageMatcher;
}(NodeMatcher);

export { PageMatcher };
export function createPage(options) {
  if (process.env.NODE_ENV !== 'production') {
    var title = options.title,
        getTitle = options.getTitle,
        meta = options.meta,
        getMeta = options.getMeta,
        content = options.content,
        getContent = options.getContent,
        other = __rest(options, ["title", "getTitle", "meta", "getMeta", "content", "getContent"]);

    var unknownKeys = Object.keys(other);

    if (unknownKeys.length) {
      console.warn("createPage() received unknown options " + unknownKeys.map(function (x) {
        return "\"" + x + "\"";
      }).join(', ') + ".");
    }

    if (title === undefined && getTitle === undefined) {
      console.warn("createPage() should be called with a \"title\" or \"getTitle\" option. If you're sure you don't want to set a title, you can silence this warning by passing \"null\" as the title.");
    }
  }

  return _a =
  /** @class */
  function (_super) {
    __extends(class_1, _super);

    function class_1() {
      return _super !== null && _super.apply(this, arguments) || this;
    }

    return class_1;
  }(PageMatcher), _a.title = options.title, _a.getTitle = options.getTitle, _a.meta = options.meta, _a.getMeta = options.getMeta, _a.content = options.content, _a.getContent = options.getContent, _a;

  var _a;
}